// this file is automatically generated by the scripts/git-version.js script
export const versions = {
  version: '0.0.0',
  revision: '80858ee4bafbe85e97ca949ef67a55da3b65fa3c',
  branch: 'master',
  date: '1793810361702'
};
